export default __webpack_public_path__ + "static/media/text-to-speech-feature.a3da4c4d.webp";